import PropTypes from 'prop-types';
import React from 'react';
import FormControl from 'react-bootstrap/lib/FormControl';
import _ from 'lodash';

import { TimeTypes, JourneyDirections } from '../../../constants/AppConstants';
import t from '../../../lib/I18n';

import Icon from '../../general/Icon';

const changeHandler = (callback) => (e) => callback(e.target.value);

function ArriveDepart ({ arriveDepart, direction, onChange, className, disabled }) {
    const labelName = direction === JourneyDirections.INWARD
        ? 'returnArriveDepart__selector'
        : 'outboundArriveDepart__selector';

    return (
        <div className={ `arrive-depart select-container ${className}` }>
            <Icon icon="dropdown" />
            <label htmlFor={ labelName } className="sr-only">
                { t('booking.dates.arriving') } / { t('booking.dates.departing') }
            </label>
            <FormControl componentClass="select"
                    disabled={ disabled }
                    name='arriveDepart'
                    id={ labelName }
                    className='arriveDepart__form-control'
                    value={ arriveDepart }
                    onChange={ changeHandler(onChange) } >
                <option value={ TimeTypes.DEPART }>{ t('booking.dates.departing') }</option>
                <option value={ TimeTypes.ARRIVE }>{ t('booking.dates.arriving') }</option>
            </FormControl>
        </div>
    );
}

ArriveDepart.propTypes = {
    arriveDepart: PropTypes.oneOf(_.values(TimeTypes)),
    direction: PropTypes.oneOf(_.values(JourneyDirections)),
    onChange: PropTypes.func,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    labelName: PropTypes.string,
};

ArriveDepart.defaultProps = {
    arriveDepart: TimeTypes.DEPART,
    direction: JourneyDirections.OUTWARD,
    onChange: _.noop,
    className: '',
    disabled: false,
};


export default ArriveDepart;



// WEBPACK FOOTER //
// ./src/components/search/dates/ArriveDepart.js